import React from "react";
import { Button } from "react-bootstrap";

export const CustomTextButton = ({
  value,
  className = "",
  color = "text-danger",
  ...props
}) => {
  return (
    <Button variant="link" className={`py-0 ${className} ${color}`} {...props}>
      {value}
    </Button>
  );
};
